import { makeAutoObservable } from 'mobx';
import { Axios } from '../utilities/network';
import RootStore from './root-store';
import { SetLocalStorage } from '../utilities/cryptography';
import { PERMISSION_ROLE_OPTIONS } from '../constants/storage-keys';

export default class PermissionStore {
  loading: boolean = false;
  deleting: boolean = false;

  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    makeAutoObservable(this, {}, { autoBind: true });
    this.rootStore = rootStore;
  }

  searchRoles = async (skip: number, take: number, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/AdminRole/Search/${skip}/${take}`, { ...reqModel });
      SetLocalStorage(PERMISSION_ROLE_OPTIONS, res.data.items);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  createRole = async (reqModel: {
    name: string,
    description: string,
    permissions: { permissionGroupId: number, permissionLevelId: number }[],
  }) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/AdminRole/`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  updateRole = async (reqModel: {
    name: string,
    description: string,
    permissions: { permissionGroupId: number, permissionLevelId: number }[],
    id: number
  }) => {
    this.loading = true;
    try {
      const res = await Axios.put(`/api/AdminRole/`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  removeRole = async (id: number) => {
    this.deleting = true;
    try {
      const res = await Axios.delete(`/api/AdminRole/${id}`);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.deleting = false;
    }
  };

}
